module.exports = __webpack_public_path__ + "static/media/feature-demo-1.0f78f3c0.jpg";